module.exports = __webpack_public_path__ + "static/media/gavel.ec480cfb.svg";